import styled from 'styled-components';
import { rem } from 'polished';
import { OptionsSelectStyled } from '../../OptionsSelectStyled';

export const OptionsSelectStyledOVGB = styled(OptionsSelectStyled)`
    .optionsTriggerWrapper {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }

    .option-card {
        border-color: ${({ theme }) => theme.colors.grey8};

        &:hover {
            border-color: ${({ theme }) => theme.colors.primary};
        }

        &__name {
            .checkbox .checkboxWrapper label::after {
                border-color: ${({ theme }) => theme.colors.white};
            }
            font-size: ${rem(16)};
        }

        &__add-priceWrapper {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .isSelected {
        border-color: ${({ theme }) => theme.colors.primary};
        background: ${({ theme }) => theme.colors.red7};
    }

    .selectedOptions {
        font-size: ${({ theme }) => theme.fontSizes.h7};
    }
`;
